// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D2Sv","badges":"styles_badges__3mZqg"};